var map = {
	"./upload-add-img.png": 370,
	"./upload-cliente.png": 2202,
	"./upload-default.png": 2203,
	"./upload-dpi.png": 2204,
	"./upload-foto.png": 466,
	"./upload-recibo.png": 2205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2201;